import { styled, css } from '@mui/material';

export const StyledCareDocumentHeaderContainer = styled('div')(
  ({ theme }) => css`
    h2 {
      margin-bottom: ${theme.spacing('MEDIUM')};
    }
  `
);
export const StyledCareDocumentBodyContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacing('LARGE')};

    p:nth-of-type(1) {
      margin-bottom: ${theme.spacing('MEDIUM')};
    }

    p:nth-of-type(2) {
      margin-bottom: ${theme.spacing('MEDIUM')};
    }
    ${theme.breakpoints.up('desktop')} {
      p:nth-of-type(1) {
        margin-bottom: ${theme.spacing('MEDIUM')};
      }

      p:nth-of-type(2) {
        margin-bottom: ${theme.spacing('LARGE')};
      }
    }
  `
);
